export default "__VITE_ASSET__Deyu0lS1__"